import { render } from "./XIconSolidChatCircleText.vue?vue&type=template&id=fc62f032"
import script from "./XIconSolidChatCircleText.vue?vue&type=script&lang=js"
export * from "./XIconSolidChatCircleText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidChatCircleText.vue"]])

export default __exports__